<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >

        <v-tabs
          v-model="currentTab"
        >
          <v-tab>
            Bestellen
          </v-tab>
          <v-tab>
            Inventar
          </v-tab>
          <v-tab>
            Ausgabe
          </v-tab>
          <v-spacer></v-spacer>
          <v-tab
            v-if="$store.getters.has_permission(['Shop_GBS_rw'])"
          >
            <v-icon
            >
              mdi-cogs
            </v-icon>
          </v-tab>
          <v-tab-item>
            <ShopOrder></ShopOrder>
          </v-tab-item>
          <v-tab-item>
            <ShopInventory
              :activeTab="currentTab"
            ></ShopInventory>
          </v-tab-item>
          <v-tab-item>
            <ShopAllocationManagement
              :activeTab="currentTab"
            ></ShopAllocationManagement>
          </v-tab-item>
          <v-tab-item>
            <ShopManage></ShopManage>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ShopOrder from "../components/shop/ShopOrder.vue";
import ShopAllocationManagement from "../components/shop/ShopAllocationManagement.vue";
import ShopInventory from "../components/shop/ShopInventory.vue";
import ShopManage from "../components/shop/ShopManage.vue";

export default {
  name: "ShopView",
  components: {
    ShopOrder,
    ShopManage,
    ShopInventory,
    ShopAllocationManagement,
  },
  data: () => ({
    currentTab: 2
  }),
  methods: {

  },
  mounted() {
    if (this.$store.state.shop.products === null) {
      this.$store.dispatch("update", { context: "/shop/products" });
    }
  }
};
</script>

<style scoped>

</style>
